'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.default = function () {
    var categoryFacetElement = document.querySelector('*[data-category-facet]');
    var selectionArea = document.querySelector('.category-selection-area');
    var categoriesFilterRegex = /\"?Categories\"?:\[[0-9\"\',]*\],?/ig;
    var categoryModel = {};
    var lastSelectedOpener = {};
    var selectedCategories = [];
    var selectedCategoryClass = 'selected-category';
    var selectedCategoryActiveClass = 'selected-category-active';
    var selectedOpenerClass = 'selected-opener';
    var categoryLevel1 = 'category-level1';

    if (categoryFacetElement && !categoryFacetElement.historyPushRegistered) {
        window.addEventListener('clearFilter', function () {
            selectedCategories = [];
        });
        window.addEventListener('pushHistory', function () {
            loadModel();
        });
        categoryFacetElement.historyPushRegistered = true;
    }

    if (categoryFacetElement && selectionArea && !categoryFacetElement.created) {
        categoryFacetElement.created = true;
        loadModel();
        selectedCategories = _common2.default.loadSelectedFiltersFromUrl(categoriesFilterRegex);
        var selected1stLev = getSelectedFirstLev();

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            var _loop = function _loop() {
                var cat1stLevel = _step.value;

                var selected1stLevClass = selected1stLev.indexOf(cat1stLevel.CategoryId.toString()) > -1 ? selectedCategoryActiveClass : '';
                var category1Element = _common2.default.createElement('div', categoryFacetElement, {
                    className: categoryLevel1 + ' ' + selected1stLevClass,
                    textContent: cat1stLevel.CategoryName,
                    id: 'category' + cat1stLevel.CategoryId
                });

                category1Element.dataset.categoryId = cat1stLevel.CategoryId;
                category1Element.addEventListener('click', function (event) {
                    openSelectionArea(event, cat1stLevel);
                });
            };

            for (var _iterator = (0, _getIterator3.default)(categoryModel), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                _loop();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }

    function loadModel() {
        categoryModel = JSON.parse(categoryFacetElement.dataset.categoryFacet);
    }

    function windowMouseMove(event) {
        if (!selectionArea.openByClick && getAllowedLeaveElements().indexOf(event.target) < 0) showSelectionArea(false);
    }

    function getChildNodesRecursive(parent) {
        var nodesArray = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        nodesArray.push(parent);
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = (0, _getIterator3.default)(parent.childNodes), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var child = _step2.value;

                getChildNodesRecursive(child, nodesArray);
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        return nodesArray;
    }

    function getAllowedLeaveElements() {
        return [].concat((0, _toConsumableArray3.default)(getChildNodesRecursive(selectionArea)), (0, _toConsumableArray3.default)(getChildNodesRecursive(categoryFacetElement)));
    }

    function showSelectionArea(show) {
        selectionArea.style.display = show ? 'block' : '';
        // remove wrap class when there are lot element
        var wrap = document.getElementsByClassName('category-selection-area');
        wrap[0].classList.remove('be-big');
        if (!show) deselectOpener(true);
    }

    function getSelectedFirstLev() {
        try {
            var foundCategories = [];
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                var _loop2 = function _loop2() {
                    var cat1st = _step3.value;

                    var cat1String = cat1st.CategoryId.toString();
                    if (selectedCategories.some(function (c) {
                        return c.toString() === cat1String;
                    })) {
                        foundCategories.push(cat1String);
                        return 'continue';
                    }
                    var _iteratorNormalCompletion4 = true;
                    var _didIteratorError4 = false;
                    var _iteratorError4 = undefined;

                    try {
                        var _loop3 = function _loop3() {
                            var cat2nd = _step4.value;

                            if (selectedCategories.some(function (c) {
                                return c.toString() === cat2nd.CategoryId.toString();
                            })) {
                                foundCategories.push(cat1String);
                                return 'continue';
                            }
                            var _iteratorNormalCompletion5 = true;
                            var _didIteratorError5 = false;
                            var _iteratorError5 = undefined;

                            try {
                                var _loop4 = function _loop4() {
                                    var cat3rd = _step5.value;

                                    if (selectedCategories.some(function (c) {
                                        return c.toString() === cat3rd.CategoryId.toString();
                                    })) {
                                        foundCategories.push(cat1String);
                                        return 'continue';
                                    }
                                };

                                for (var _iterator5 = (0, _getIterator3.default)(cat2nd.ChildCategories), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                                    var _ret4 = _loop4();

                                    if (_ret4 === 'continue') continue;
                                }
                            } catch (err) {
                                _didIteratorError5 = true;
                                _iteratorError5 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                        _iterator5.return();
                                    }
                                } finally {
                                    if (_didIteratorError5) {
                                        throw _iteratorError5;
                                    }
                                }
                            }
                        };

                        for (var _iterator4 = (0, _getIterator3.default)(cat1st.ChildCategories), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                            var _ret3 = _loop3();

                            if (_ret3 === 'continue') continue;
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                _iterator4.return();
                            }
                        } finally {
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }
                };

                for (var _iterator3 = (0, _getIterator3.default)(categoryModel), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var _ret2 = _loop2();

                    if (_ret2 === 'continue') continue;
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            return foundCategories;
        } catch (e) {
            console.error('Error in getSelectedElementsTreeRec', e);
            return [];
        }
    }

    function deselectOpener(wholeGroup) {
        var selector = wholeGroup ? selectedCategoryClass : selectedOpenerClass;

        var elementList = categoryFacetElement.querySelectorAll('.' + selector);
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
            for (var _iterator6 = (0, _getIterator3.default)(elementList), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                var element = _step6.value;

                element.classList.remove(selector);
            }
        } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                    _iterator6.return();
                }
            } finally {
                if (_didIteratorError6) {
                    throw _iteratorError6;
                }
            }
        }

        setClassForSelected1StCat();
    }

    function setClassForSelected1StCat() {
        var selectedCategory1stLev = getSelectedFirstLev();
        var elementList = [].concat((0, _toConsumableArray3.default)(categoryFacetElement.querySelectorAll('.' + categoryLevel1)));
        var _iteratorNormalCompletion7 = true;
        var _didIteratorError7 = false;
        var _iteratorError7 = undefined;

        try {
            for (var _iterator7 = (0, _getIterator3.default)(elementList), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                var element = _step7.value;

                if (selectedCategory1stLev.indexOf(element.dataset.categoryId.toString()) > -1) element.classList.add(selectedCategoryActiveClass);else element.classList.remove(selectedCategoryActiveClass);
            }
        } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion7 && _iterator7.return) {
                    _iterator7.return();
                }
            } finally {
                if (_didIteratorError7) {
                    throw _iteratorError7;
                }
            }
        }
    }

    function openSelectionArea(event, categoryItem) {
        var openerElement = event.target;
        selectionArea.style = '';

        document.addEventListener('click', function (clEvent) {
            if (getAllowedLeaveElements().indexOf(clEvent.target) < 0) {
                window.removeEventListener('click', windowMouseMove);
                categoryFacetElement.mouseMoveRegistered = false;
                showSelectionArea(false);
            }
        });

        showSelectionArea(true);
        var id = /[0-9]+/.exec(categoryItem.CategoryId).shift();

        var firstChb = selectionArea.querySelector('#firstLevelCheckbox');
        if (firstChb) {
            firstChb.checked = getSelectedCategoryItem(id);
            firstChb.parentElement.dataset.categoryId = id;
            registerCategorySelected(firstChb);
        }

        deselectOpener(true);
        openerElement.classList.add(selectedCategoryClass);
        var openerClientRect = openerElement.getBoundingClientRect();

        selectionArea.style.left = openerClientRect.width + 'px';

        var categorySelectionTitle = selectionArea.querySelector('.category-selection-title');
        if (categorySelectionTitle) categorySelectionTitle.textContent = categoryItem.CategoryName;

        fillSecondLevel(selectionArea, categoryItem);
        lastSelectedOpener = openerElement;

        if (!categoryFacetElement.mouseMoveRegistered) {
            window.addEventListener('click', windowMouseMove);
            categoryFacetElement.mouseMoveRegistered = true;
        }

        var leftSection = selectionArea.querySelector('.category-selection-left');

        addExtraClassForManyItems(leftSection);
        wrapAllRightItems();
        var rightSection = selectionArea.querySelector('.category-selection-right__wrap');
        addExtraClassForManyItems(rightSection);
    }

    function wrapAllRightItems() {
        var rightSection = selectionArea.querySelectorAll('.category-selection-right');
        var wrap = document.getElementsByClassName('category-selection-main');
        var rightWrap = document.createElement('div');
        rightWrap.className = "category-selection-right__wrap";
        wrap[0].insertBefore(rightWrap, wrap[0].lastElementChild);

        rightSection.forEach(function (el) {
            rightWrap.appendChild(el);
        });
    }

    function addExtraClassForManyItems(section) {
        var sectionHeight = section.getBoundingClientRect().height;
        var wrap = document.getElementsByClassName('category-selection-area');
        var wrapClientRectHeight = wrap[0].getBoundingClientRect().height;

        section.classList.remove('column-2');
        if (sectionHeight > wrapClientRectHeight) {
            section.classList.add('column-2');
            wrap[0].classList.add('be-big');
        }
    }

    function getSelectedCategoryItem(id) {
        if (!id || !selectedCategories) return false;
        var idString = id.toString();
        return selectedCategories.some(function (sc) {
            return sc === id || sc === idString;
        });
    }

    function fillSecondLevel(selectionArea, categoryItem) {
        // main section
        var categorySelectionPane = selectionArea.querySelector('.category-selection-main');
        if (!categorySelectionPane) return;
        categorySelectionPane.innerHTML = '';

        var index = 0;
        var _iteratorNormalCompletion8 = true;
        var _didIteratorError8 = false;
        var _iteratorError8 = undefined;

        try {
            for (var _iterator8 = (0, _getIterator3.default)(categoryItem.ChildCategories), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                var secondLevelCategory = _step8.value;


                // create node for 2nd level
                var categorySelection = _common2.default.createElement('div', categorySelectionPane, { className: 'category-selection-' + (index ? 'right' : 'left') });
                createNoteForLevel(categorySelection, secondLevelCategory);

                // create nodes for 3rd level
                var _iteratorNormalCompletion9 = true;
                var _didIteratorError9 = false;
                var _iteratorError9 = undefined;

                try {
                    for (var _iterator9 = (0, _getIterator3.default)(secondLevelCategory.ChildCategories), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                        var thirdLevelCategory = _step9.value;

                        createNoteForLevel(categorySelection, thirdLevelCategory, true);
                    }
                } catch (err) {
                    _didIteratorError9 = true;
                    _iteratorError9 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion9 && _iterator9.return) {
                            _iterator9.return();
                        }
                    } finally {
                        if (_didIteratorError9) {
                            throw _iteratorError9;
                        }
                    }
                }

                index++;
            }
        } catch (err) {
            _didIteratorError8 = true;
            _iteratorError8 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion8 && _iterator8.return) {
                    _iterator8.return();
                }
            } finally {
                if (_didIteratorError8) {
                    throw _iteratorError8;
                }
            }
        }
    }

    function createNoteForLevel(categorySelection, categoryItem, isForThirdLevel) {
        var id = categoryItem.CategoryId;
        var chbId = isForThirdLevel ? 'thirdCategory_' + id : 'secondCategory_' + id;
        var catWrapper = _common2.default.createElement('div', categorySelection, !isForThirdLevel ? { className: 'second-level' } : null);
        catWrapper.dataset.categoryId = id;
        var catCheckbox = _common2.default.createElement('input', catWrapper, {
            type: 'checkbox', id: chbId, checked: getSelectedCategoryItem(id)
        });
        catCheckbox.createdByJs = true;
        registerCategorySelected(catCheckbox);
        var catLabel = _common2.default.createElement('label', catWrapper, {
            for: chbId, textContent: categoryItem.CategoryName
        });
        registerCategorySelected(catLabel);
    }

    function registerCategorySelected(element) {
        element.addEventListener('click', function (event) {
            window.removeEventListener('click', windowMouseMove);
            deselectOpener();
            element.classList.add(selectedOpenerClass);
            selectCheckBox(event);
        });
    }

    function selectCheckBox(event) {
        var categoryItemWrapper = event.target.parentElement;
        var checkbox = categoryItemWrapper.querySelector('input[type=checkbox]');
        if (!checkbox) {
            return false;
        } else {
            // checkboxes in this project are not classic checkboxes, so they need to be initialized on load,
            // but for those created by js, this does not work, so this is workaround
            if (checkbox.createdByJs) checkbox.checked = !checkbox.checked;
            categoryItemWrapper.dataset.categorySelected = checkbox.checked ? 'true' : 'false';

            var categoryId = parseInt(categoryItemWrapper.dataset.categoryId || '0');

            checkByParams(checkbox.checked, categoryId);
            var currentLeaf = recGetCurrentLeaf(categoryModel, categoryId);
            recCheckChildren(currentLeaf, checkbox.checked);
            _common2.default.updateSearchQuery(categoriesFilterRegex, selectedCategories);
            setClassForSelected1StCat();
            return checkbox.checked;
        }
    }

    function recGetCurrentLeaf(categoryItem, categoryId) {
        // find (recursively) current category data item in data model tree
        var _iteratorNormalCompletion10 = true;
        var _didIteratorError10 = false;
        var _iteratorError10 = undefined;

        try {
            for (var _iterator10 = (0, _getIterator3.default)(categoryItem), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                var childItem = _step10.value;

                if (childItem.CategoryId === categoryId) return childItem;
                var grandChild = recGetCurrentLeaf(childItem.ChildCategories || [], categoryId);
                if (grandChild) return grandChild;
            }
        } catch (err) {
            _didIteratorError10 = true;
            _iteratorError10 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion10 && _iterator10.return) {
                    _iterator10.return();
                }
            } finally {
                if (_didIteratorError10) {
                    throw _iteratorError10;
                }
            }
        }

        return null;
    }

    function recCheckChildren(parent, check) {
        // prepare data for check/uncheck child checkboxes of current item
        if (!parent) return;

        var _iteratorNormalCompletion11 = true;
        var _didIteratorError11 = false;
        var _iteratorError11 = undefined;

        try {
            for (var _iterator11 = (0, _getIterator3.default)(parent.ChildCategories), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                var child = _step11.value;

                var checkbox = getCheckboxByCategoryId(child.CategoryId);
                if (!checkbox) continue;
                checkbox.checked = check;
                checkByParams(check, child.CategoryId);
                recCheckChildren(child, check);
            }
        } catch (err) {
            _didIteratorError11 = true;
            _iteratorError11 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion11 && _iterator11.return) {
                    _iterator11.return();
                }
            } finally {
                if (_didIteratorError11) {
                    throw _iteratorError11;
                }
            }
        }
    }

    function getCheckboxByCategoryId(categoryId) {
        return selectionArea.querySelector('*[data-category-id="' + categoryId + '"] > input[type=checkbox]');
    }

    function checkByParams(check, categoryId) {
        var isSelected = getSelectedCategoryItem(categoryId);
        // check
        if (check && !isSelected) {
            selectedCategories.push(categoryId);
        }
        // uncheck
        if (!check && isSelected) {
            selectedCategories.splice(selectedCategories.indexOf(categoryId), 1);
            recUncheckParentOnUncheckSelf(categoryId);
        }
    }

    function recUncheckParentOnUncheckSelf(categoryId) {
        // recursively uncheck parent of actually unchecked child checkbox, resp. prepare data model
        var currentLeaf = recGetCurrentLeaf(categoryModel, categoryId);
        var parentCategoryId = currentLeaf.ParentCategoryId;
        if (!currentLeaf || !parentCategoryId) return;

        var parentIndex = selectedCategories.indexOf(parentCategoryId);
        if (parentIndex < 0) return;

        var checkbox = getCheckboxByCategoryId(parentCategoryId);
        if (checkbox) checkbox.checked = false;

        selectedCategories.splice(parentIndex, 1);
        recUncheckParentOnUncheckSelf(parentCategoryId);
    }
};

var _common = require('../utils/common');

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/facetsVanilla.js
// module id = 940
// module chunks = 0